<template>
  <div class="container">
    <div class="title animate-target" v-animate-in>
      Part 1
      <hr/>
    </div>
    <h1 class="animate-target" v-animate-in>{{$route.meta.sub_header}}</h1>
    <p class="animate-target" v-animate-in>In this first part you will answer a pre-activity quiz to test your knowledge prior to completing the learning module. Each part concludes with a check-in question.</p>
    <p class="animate-target" v-animate-in>Then, the module concludes with a final quiz.</p>
    <router-link to="/section1/1-1" class="btn btn_kerendia animate-target" v-animate-in>Start pre-activity quiz</router-link>
  </div>
</template>

<script>
export default {
  name: "s1_sub_index"
}
</script>

<style scoped>
  @import "../../assets/css/section1/s1.css";
</style>
